import { render } from "./HeaderToolbar.vue?vue&type=template&id=4a872b9e"
import script from "./HeaderToolbar.vue?vue&type=script&lang=js"
export * from "./HeaderToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__